import { useMutation } from '@tanstack/react-query';

import { modifySubscription } from '@features/Stripe/api';
import { userAtom } from '@features/Stripe/atoms';
import { useAtomValue } from 'jotai/index';
import { useGetAppName } from 'src/utils/hooks';

interface ModifySubscriptionParams {
  newPlanId: string;
  paymentSystem?: 'braintree' | 'stripe';
  email?: string;
  userId?: number | string;
  [key: string]: any;
}

export const useModifySubscription = () => {
  const { email, userId, customerId } = useAtomValue(userAtom);
  const app = useGetAppName();

  return useMutation({
    mutationKey: ['modifySubscription'],
    mutationFn: async ({
      newPlanId,
      paymentSystem = 'stripe',
      ...overrides
    }: ModifySubscriptionParams) => {
      if (!newPlanId) {
        throw new Error('The parameter "newPlanId" is required.');
      }

      const payload = {
        email,
        userId,
        newPlanId,
        paymentSystem,
        customerId: customerId,
        app: app,
        ...overrides,
      };

      return modifySubscription(payload);
    },
  });
};
